/* eslint-disable react/prop-types */
import React from "react"
import Layout from "../../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import Seo from "../../components/seo"
import { graphql } from "gatsby"
import Line from "../../images/line.svg"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import Bewertungsformular from "../../components/bewertungsformular"

const Bewertungen = ({ data }) => (
  <Layout>
    <Seo title="Bewertungen" />
    <div className="reisen-liste-headline">
      <h1>Bewertungen </h1>
      <img className="line" src={Line}></img>
    </div>
    <section className="mt-16 max-w-[920px] mx-auto">
      <Bewertungsformular />
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2 }}>
        <Masonry>
          {data.contentfulBewertungen.testimonials.map((entry) => (
            <div
              className="relative flex flex-col gap-2 m-4 p-8 border shadow bg-slate-50"
              key={entry.id}
            >
              {entry.bild && (
                <div>
                  <GatsbyImage
                    className=""
                    alt={entry.name}
                    image={entry.bild.gatsbyImageData}
                  />
                </div>
              )}
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: entry.text.childMarkdownRemark.html,
                }}
              ></div>
              <span className="font-serif absolute top-0 left-0 text-8xl m-0 p-0 text-slate-500 opacity-10">
                “
              </span>
              <span className="font-serif absolute bottom-0 right-0 text-8xl m-0 p-0 text-slate-500 opacity-10">
                ”
              </span>

              <div className="flex flex-row items-center gap-2">
                {entry.profilbildAutor && (
                  <GatsbyImage
                    className="rounded-full"
                    alt={entry.autor}
                    image={entry.profilbildAutor.gatsbyImageData}
                  />
                )}

                <div className="testimonial-author">{entry.name}</div>
              </div>
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </section>
  </Layout>
)

export const query = graphql`
  {
    contentfulBewertungen(id: { eq: "7d45e486-9cf7-5238-94f1-a5cd95ef1407" }) {
      testimonials {
        name
        text {
          childMarkdownRemark {
            html
          }
        }
        bild {
          gatsbyImageData(layout: FULL_WIDTH)
        }
        profilbildAutor {
          gatsbyImageData(layout: FIXED, height: 60, width: 60)
        }
      }
    }
  }
`

export default Bewertungen
